const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";

module.exports = SOCKET_URL;
